import {
  BooleanInput,
  Edit,
  required,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { CoronerAddressInputs, coronerAddressTransform } from './CoronerAddressInputs';

export const CoronersEdit = () => (
  <Edit transform={coronerAddressTransform} mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="id" label="OCC ID" disabled helperText="Government dropdown id (immutable)" />
      <TextInput source="name" validate={[required()]} fullWidth />
      <CoronerAddressInputs />
      <BooleanInput source="active" />
    </SimpleForm>
  </Edit>
);
